export const nebecaTabList = [
  {
    id: 'apply',
    label: '신청방법',
  },
  {
    id: 'issued',
    label: '발급꿀팁',
  },
  {
    id: 'subject',
    label: '발급대상자',
  },
  {
    id: 'incentive',
    label: '훈련장려금',
  },
]

export const nebecaApplyFlow = [
  {
    title: '고용 24 회원가입',
    frontDesc: '고용24에 접속 후',
    boldLabel: '개인회원',
    backDesc: '으로 회원가입을 진행해주세요.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/card_apply_1.png',
    mobileImgUrl: 'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/card_apply_m_1.png',
  },
  {
    title: '국민내일배움카드 발급 신청',
    frontDesc: '메인화면의',
    boldLabel: '국민내일배움카드 발급신청',
    backDesc: '아이콘을 클릭하고 인증서 로그인 페이지로 넘어가 주세요.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/card_apply_2.png',
    mobileImgUrl: 'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/card_apply_m_2.png',
  },
  {
    title: '인증서 로그인',
    frontDesc: '금융인증서, 간편인증, 공동인증서 중 하나로',
    boldLabel: '로그인',
    backDesc: '을 해주세요.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/card_apply_3.png',
    mobileImgUrl: 'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/card_apply_m_3.png',
  },
  {
    title: '발급신청 절차 확인',
    frontDesc: '로그인 이후',
    boldLabel:
      '①국민내일배움카드 신청자격 확인 > ②권리 및 의무사항 > ③발급신청서 작성 > ④동의 및 신청',
    backDesc: '까지 차례로 체크 후 신청버튼 클릭하여 발급 신청을 완료해주세요.',
    imgUrl: 'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/card_apply_4.png',
    mobileImgUrl: 'https://d35ai18pny966l.cloudfront.net/course/bootcamp_index/card_apply_m_4.png',
    cautionToggle: true,
  },
]
export const possiblePeople = [
  '일자리를 구하고 있는 취준생',
  '다른 분야에 관심이 가는 이직 희망자',
  '업무역량을 향상시키고 싶은 재직자',
  '대학교 3학년 이상의 졸업예정자',
  '은퇴 후 새로운 인생을 준비하는 중/장년층',
  '졸업까지 남은 수업연한이 2년 이내인 대학(원)생',
]
export const impossiblePeople = [
  '공무원, 사립학교 교직원',
  '75세 이상인 사람',
  '45세 미만의 월 임금 300만원 이상 대기업 종사자',
  '월평균 소득 500만원 이상의 특수 형태 근로 종사자',
  '연 매출 4억원 이상의 자영업자',
  '월 소득 300만원 이상인 비영리단체 대표',
  '졸업이 2년 초과하여 남은 대학(원)생, 고등학교 1~2학년생',
  '사업 기간이 1년 미만이거나 월 소득 300만원 이상인 법인대표',
]
